import { z } from "zod";

export const launchDarklyOptionsSchema = z.object({
	clientSideId: z.string().trim().min(1),
	baseUrl: z.url({ protocol: /^https?$/ }),
	streamUrl: z.url({ protocol: /^https?$/ }),
	eventsUrl: z.url({ protocol: /^https?$/ }),
});

export type LaunchDarklyOptions = z.infer<typeof launchDarklyOptionsSchema>;
